import { E } from '@angular/cdk/keycodes';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { AccionesRntEntry } from 'src/app/shared/entrys/acciones-rnt.entry';


import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { CertificadoEntry } from 'src/app/shared/entrys/certificado.entry';
import { DepartamentoEntry } from 'src/app/shared/entrys/departamento.entry';
import { MunicipioEntry } from 'src/app/shared/entrys/municipio.entry';
import { AccionesRntType } from 'src/app/shared/enumeraciones/acciones-rnt.enum';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AccionRntService } from '../../configuracion/accion-rnt/accion-rnt.service';
import { CampoAdicionalCategoriaService } from '../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service';
import { DocumentoSubcategoriaService } from '../../configuracion/documento-subcategoria/documento-subcategoria.service';
import { ModuloAyudaService } from '../../configuracion/modulo-ayuda/modulo-ayuda.service';
import { UsuarioService } from '../../configuracion/usuario/usuario.service';
import { ReportesEstablecimientosService } from '../establecimientos/reportes-establecimientos.service';
import { ReportesCertificadoService } from './reportes-certificados.service';

@Component({
  selector: 'app-reportes-certificados',
  templateUrl: './reportes-certificados.component.html',
  styleUrls: ['./reportes-certificados.component.scss']
})
export class ReportesCertificadosComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  fecha_inicio_expedicion: any;
  fecha_inicio_vencimiento: any;
  headerTabla: Array<string>;
  formUsuario: FormGroup;
  camarasLista: Array<CamaraComercioEntry> = [];
  paginaActual: number;
  accionesRnt: Array<AccionesRntEntry>;
  adminSuper = RolesUsuario.AdministradorSuper;
  prestador = RolesUsuario.Prestador;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  camaraComercio: string;
  // selects
  categoria: Array<any> = [];
  subcategoria: Array<any> = [];
  estadoRnt: Array<any> = [];
  tipoRNT: Array<any> = [];
  departamento: Array<DepartamentoEntry> = [];
  municipio: Array<MunicipioEntry> = [];
  // checkBox
  camaraCheck = false;
  razonSocialCheck = false;
  nitCheck = false;
  departamentoCheck = false;
  municipioCheck = false;
  tipoRntCheck = false;
  numeroRntCheck = false;
  categoriaCheck = false;
  camaraUser: string = null;
  subcategoriaCheck = false;
  estadoRntCheck = false;
  isSelect: boolean;
  exportarForm: FormGroup;
  exportarList = [
    { id: 'Camara', name: 'Cámara de Comercio' },
    { id: 'Municipio', name: 'Municipio' },
    { id: 'Departamento', name: 'Departamento' },
    { id: 'Razon_Social_Establecimiento', name: 'Razón social Establecimiento' },
    { id: 'Razon_Social_Prestador', name: 'Razón social Prestador' },
    { id: 'Numero_Identificacion', name: 'Número identificación' },
    { id: 'Codigo_Certificado_Unico', name: 'Código certificado único' },
    { id: 'Codigo_Rnt', name: 'Código Rnt' },
    { id: 'Tipo_Rnt', name: 'Tipo Rnt' },
    { id: 'Categoria', name: 'Categoria' },
    { id: 'Subcategoria', name: 'Sub-categoria' },
    { id: 'Estado_Rnt', name: 'Estado Rnt' },
    { id: 'Fecha_Inscripcion', name: 'Fecha Inscripción' },
    { id: 'Fecha_Vencimiento', name: 'Fecha Vencimiento' },
    { id: 'Usuario_Creacion', name: 'Usuario Creación' },
    { id: 'Rol', name: 'Rol' },
    { id: 'Ruta_Url', name: 'Url' },
  ];

  constructor(private formBuilder: FormBuilder, private reporteService: ReportesCertificadoService,
    private establecimientoComercioService: EstablecimientoComercioService, public authService: AuthService,
    private categoriaService: CampoAdicionalCategoriaService, private basicasLoVService: BasicasLoVService,
    private reportesEstablecimientos: ReportesEstablecimientosService,
    private estadoRntService: AccionRntService, private tipoRntService: ModuloAyudaService) {
    this.createPagingTable();
    this.createForm();

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(control => new FormControl(false));
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl
    });

    this.paginaActual = 1;
  }

  ngOnInit(): void {
    this.titleTable();
    this.onCamaraSelect();
    this.onDepartamentosSelect();
    this.onCategoriaSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
    this.onChanges();
  }
  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      numero_identificacion: [null],
      tipo_rnt: [null],
      fecha_expedicion_desde: [null],
      fecha_expedicion_hasta: [null],
      fecha_vencimiento_desde: [null],
      fecha_vencimiento_hasta: [null],
      codigo_municipio: [null],
      codigo_departamento: [null],
      codigo_rnt: [null],
      codigo_categoria: [null],
      estado_rnt: [null],
      codigo_certificado_unico: [null]
    });

  }
  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging
    } as DatoPaginadoModel;
  }
  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarCertificados(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarCertificados(1);
  }
  onConsultarCertificados(page: number) {
    this.reporteService.getDataTable({ ...this.filtro.value, numeroPagina: page })
      .subscribe(resultado => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }
  limpiar() {
    this.filtro.reset();
    this.createPagingTable();
    this.titleTable();
    this.onCamaraSelect();
    this.onDepartamentosSelect();
    this.onCategoriaSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
  }

  titleTable() {

    if (this.authService.getRolUser(this.adminSuper)) {
      this.headerTabla = ['Cámara de comercio', 'Departamento', 'Municipio', 'Nombre o Razón Social del Establecimiento',
        'NIT del Propietario', 'Razón social/nombre', 'Código de certificado', 'Número del RNT', 'Tipo de RNT', 'Categoria',
        'Sub-categoria', 'Estado RNT', 'Fecha de Expedición', 'Fecha Vencimiento',
        'Nombre', 'Rol de usuario', 'URL', 'Ver Copia Certificado'];
    } else {
      this.headerTabla = ['Cámara de comercio', 'Departamento', 'Municipio', 'Nombre o Razón Social del Establecimiento',
        'NIT del Propietario', 'Razón social/nombre', 'Código de certificado', 'Número del RNT', 'Tipo de RNT', 'Categoria',
        'Sub-categoria', 'Estado RNT', 'Fecha de Expedición', 'Fecha Vencimiento',
        'Nombre', 'Rol de usuario', 'URL'];
    }
  }





  onChanges() {
    this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
      this.exportarForm
        .get('exportarList')
        .patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
    });

    this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
      const allSelected = val.every(bool => bool);
      if (this.exportarForm.get('selecAll').value !== allSelected) {
        this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls.map(control => control.value)
        .reduce((prev, next) => next ? prev + next : prev, 0);

      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked, index) => checked ? this.exportarList[index].id : null)
      .filter(value => value !== null);
    let date = new Date();
    this.columnasEnvio = selectedPreferences.join();

    this.reporteService.generarExportarCertificados({ ...this.filtro.value, columnas: this.columnasEnvio })
      .subscribe((resultado: HttpResponse<Blob>) => {
        this.saveAsExcelFile(resultado, `reporte_certificados${date.toLocaleDateString()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}.xlsx`);
      });

  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }


  onLoadAcciones(rntPrestadorEntry: any) {
    this.reporteService
      .getAccionesPorRnt(rntPrestadorEntry)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.accionesRnt = [{
            ruta_url: 'expedir-certificado',
            accion: 'Descargar Certificado',
            activo: true,
            estado_rnt_id: 1,
            estado_solicitud_id: 1,
            orden: 1,
            tipo_solicitud_id: 1,
            usuario_auditoria: ''
          }];
        }
      });
  }
  onAcciones(
    certificadoEntry: CertificadoEntry,
    accionesRnt: AccionesRntEntry
  ) {
    switch (accionesRnt.ruta_url) {
      case AccionesRntType.ExpedirCertificado:
        this.descargarCertificado(certificadoEntry.certificado_generado_id);
        break;

    }
  }
  descargarCertificado(certificado_generado_id: number) {
    this.reporteService
      .descargarCertificado({ certificado_generado_id })
      .subscribe(response => {
        this.downloadPDF(response.body.data.file_data, response.body.data.nombre);
      })
  }

  onCheckDateInicio(minDate: NgbDate) {
    this.fecha_inicio_expedicion = { day: minDate.day, month: minDate.month, year: minDate.year };
  }
  onCheckDateVencimiento(minDate: NgbDate) {
    this.fecha_inicio_vencimiento = { day: minDate.day, month: minDate.month, year: minDate.year };
  }
  downloadPDF(pdf: string, name: string) {
    const linkSource = `${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  //MAESTROS
  onCategoriaSelect() {
    this.categoriaService.getCategoria().subscribe(resultado => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }
  onDepartamentosSelect() {
    if (this.filtro.value.codigo_camara == null) {
      this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
        if (resultado.result) {
          this.departamento = resultado.data as Array<DepartamentoEntry>;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getDepartamento({ codigo_camara: this.filtro.value.codigo_camara })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.departamento = resultado.data as Array<DepartamentoEntry>;
            this.onMunicipioSelect();
          }
        });
    }
  }
  onMunicipioSelect() {
    // tslint:disable-next-line:triple-equals
    if (
      this.filtro.value.codigo_camara == null &&
      this.filtro.value.codigo_departamento == null
    ) {
      this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
        if (resultado.result) {
          this.municipio = resultado.data as Array<MunicipioEntry>;
        }
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.reportesEstablecimientos
        .getMunicipio({
          codigo_camara: this.filtro.value.codigo_camara,
          departamento_id: this.filtro.value.codigo_departamento,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.municipio = resultado.data as Array<MunicipioEntry>;
          }
        });
    }
  }
  onEstadoRNTSelect() {
    this.estadoRntService.getEstadosRNT().subscribe(resultado => {
      if (resultado.result) {
        this.estadoRnt = resultado.data;
      }
    });
  }

  onTipoRNTSelect() {
    this.tipoRntService.getTipoRnt().subscribe(resultado => {
      if (resultado.result) {
        this.tipoRNT = resultado.data;
      }
    });
  }
  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe(resultado => {
      if (resultado) {
        if (this.authService.getTipoUser() !== "1") {
          this.camaraUser = this.authService.getCamaraUser();
          let selectedCamara = resultado.data.find(option => option.codigo_camara === this.camaraUser);
          this.camarasLista = selectedCamara ? [selectedCamara] : [];

        } else {
          this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        }
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro.get('codigo_camara').patchValue(this.authService.getCamaraUser());
          this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
            this.authService.getCamaraUser()).desc_camara);

        }
        this.onDepartamentosSelect();
      }
    });
  }


}
